import { SvgIcon, type SxProps, type Theme } from '@mui/material';
import React from 'react';
import CircleTake from '../../assets/CircleTake.svg';
import GrayCircleTake from '../../assets/GrayCircleTake.svg';

type Props = {
    gray?: boolean;
    sx?: SxProps<Theme>
}

export default function CircleTakeIcon({ gray, sx = []}: Props) {
    if (gray) return (
        <SvgIcon sx={[ ...(Array.isArray(sx) ? sx : [sx]) ]} color='disabled' component={GrayCircleTake} inheritViewBox />
    )

    return (
        <SvgIcon sx={[ ...(Array.isArray(sx) ? sx : [sx]) ]} color='disabled' component={CircleTake} inheritViewBox />
    )
}